function Api () {
  this.base_url = 'https://knesunderland.clubspeedtiming.com/api/index.php/';
  this.api = 'LDai18udl09uFs26Miv1';
  this.limit = 200;
}

Api.prototype.checkResponse = function( response ){
  if( !response.ok ){
    return Promise.reject(new Error(response.statusText))
  } else {
    return Promise.resolve(response)
  }
}

Api.prototype.returnJson = function( response ){
  return response.json()
}


export default Api;
